import React, { useEffect, useMemo, useRef, useState } from "react";
import { Box, HStack, Select, Text } from "@chakra-ui/react";
import { CPTSlabForManualOption } from "../../../../views/Orders/enums";
import { MANUAL_CPT_SLAB_OPTIONS } from "../constants/manualCptSlabOptions";

export interface CPTSlabSelectorProps {
  value?: CPTSlabForManualOption;
  onChange: (val: CPTSlabForManualOption) => void;
  isDisabled?: boolean;
}

export const CPTSlabSelector: React.FC<CPTSlabSelectorProps> = ({
  value,
  onChange,
  isDisabled,
}) => {
  const measureRef = useRef<HTMLSpanElement>(null);
  const [selectWidth, setSelectWidth] = useState<number>(130);

  const displayText = useMemo(() => {
    if (!value) return "Select Delivery Type";
    const opt = MANUAL_CPT_SLAB_OPTIONS.find((o) => o.value === value);
    return opt ? `${opt.icon} ${opt.label}` : "Select Delivery Type";
  }, [value]);

  useEffect(() => {
    if (measureRef.current) {
      const textWidth = measureRef.current.offsetWidth;
      setSelectWidth(textWidth + 30);
    }
  }, [displayText]);

  return (
    <HStack spacing={2} align="center">
      <Box
        as="span"
        ref={measureRef}
        position="absolute"
        visibility="hidden"
        whiteSpace="nowrap"
        fontSize="12px"
        fontWeight="600"
      >
        {displayText}
      </Box>
      <Select
        size="xs"
        variant="outline"
        bg="white"
        fontSize="12px"
        fontWeight="600"
        height="24px"
        borderRadius="md"
        value={value || ""}
        onChange={(e) => {
          onChange(Number(e.target.value) as CPTSlabForManualOption);
          e.target.blur();
        }}
        isDisabled={isDisabled}
        placeholder="Select Delivery Type"
        _hover={{ borderColor: "gray.300" }}
        _focus={{
          borderColor: "blue.400",
          boxShadow: "0 0 0 1px var(--chakra-colors-blue-400)",
        }}
        sx={{
          paddingLeft: "4px",
          paddingRight: "22px",
          paddingInlineEnd: "22px !important",
          width: "160px",
        }}
      >
        {MANUAL_CPT_SLAB_OPTIONS.map((opt) => (
          <option key={opt.value} value={opt.value}>
            {opt.icon} {opt.label}
          </option>
        ))}
      </Select>
    </HStack>
  );
};
